"use strict";
var Observable_1 = require('../../Observable');
var toArray_1 = require('../../operator/toArray');
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/toArray.js
// module id = 532
// module chunks = 14